/* TrustCenterInfo.tsx generated by @compiled/babel-plugin v0.36.0 */
import { ax, ix, CC, CS } from "@compiled/react/runtime";
import LibraryIcon from '@atlaskit/icon/core/library';
import Lozenge from '@atlaskit/lozenge';
import { usePrivacySecurityAnalytics } from '@atlassian/mpac-analytics';
import { useStatsig } from '@atlassian/mpac-feature-flags';
import { H5, LinkWithIcon } from '@atlassian/mpac-primitives';
import { ANALYTICS_EVENT_CONTAINER_OVERVIEW_TAB, ANALYTICS_OVERVIEW_TRUST_CENTER_UI_LINK } from '../../constants';
import { InfoList, InfoListItem, InfoListItemIcon, ItemDescription, SubSection } from '../styles';
import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
const _5 = "._1e0c1o8l{display:inline-block}";
const _4 = "._4cvr1h6o{align-items:center}";
const _3 = "._1e0c1txw{display:flex}";
const _2 = "._1bsb1osq{width:100%}";
const _ = "._zulpu2gc{gap:var(--ds-space-100,8px)}";
const lozengeContainerStyles = null;
const headerStyles = null;
export const TrustCenterInfo = props => {
  const {
    trustCenterUrl
  } = props;
  const {
    enableTrustCenterSection,
    enableTrustCenterNewLozenge
  } = useStatsig();
  const {
    fireLinkEvent
  } = usePrivacySecurityAnalytics();
  if (!enableTrustCenterSection() || !trustCenterUrl) {
    return null;
  }
  const linkText = 'Check out partner trust center';
  const onTrustCenterLinkClick = () => {
    fireLinkEvent(ANALYTICS_OVERVIEW_TRUST_CENTER_UI_LINK, {
      source: ANALYTICS_EVENT_CONTAINER_OVERVIEW_TAB,
      linkText
    });
  };
  return /*#__PURE__*/_jsxs(SubSection, {
    children: [/*#__PURE__*/_jsxs(CC, {
      children: [/*#__PURE__*/_jsx(CS, {
        children: [_, _2, _3, _4]
      }), /*#__PURE__*/_jsxs("div", {
        className: ax(["_zulpu2gc _1bsb1osq _1e0c1txw _4cvr1h6o"]),
        children: [/*#__PURE__*/_jsx(H5, {
          as: "h4",
          children: "Trust center"
        }), enableTrustCenterNewLozenge() && /*#__PURE__*/_jsxs(CC, {
          children: [/*#__PURE__*/_jsx(CS, {
            children: [_5]
          }), /*#__PURE__*/_jsx("div", {
            className: ax(["_1e0c1o8l"]),
            children: /*#__PURE__*/_jsx(Lozenge, {
              appearance: "new",
              children: "New"
            })
          })]
        })]
      })]
    }), /*#__PURE__*/_jsx(InfoList, {
      children: /*#__PURE__*/_jsxs(InfoListItem, {
        children: [/*#__PURE__*/_jsx(InfoListItemIcon, {
          children: /*#__PURE__*/_jsx(LibraryIcon, {
            label: "Trust Center Info",
            spacing: "spacious"
          })
        }), /*#__PURE__*/_jsxs("div", {
          children: [/*#__PURE__*/_jsx(ItemDescription, {
            children: "Access the partner's trust center to review their security, compliance and privacy information for this app."
          }), /*#__PURE__*/_jsx(LinkWithIcon, {
            href: trustCenterUrl,
            type: "external",
            size: "medium",
            onClick: () => onTrustCenterLinkClick(),
            "aria-label": linkText,
            children: linkText
          })]
        })]
      })
    })]
  });
};